import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {merge, Observable} from "rxjs";
import {filter, map, switchMapTo} from "rxjs/operators";
import {ObservableBaseForm} from "../../shared/forms/observable-base.form";
import {LotNumberRequestModel} from "../models/cofa-widget/lot-number-request.model";

export class LotNumberRequestForm extends ObservableBaseForm<LotNumberRequestModel> {
    public get lotNumber(): AbstractControl {
        return this.formInstance.get("lotNumber") as AbstractControl;
    }

    public get name(): AbstractControl {
        return this.formInstance.get("name") as AbstractControl;
    }

    public get org(): AbstractControl {
        return this.formInstance.get("org") as AbstractControl;
    }

    public get email(): AbstractControl {
        return this.formInstance.get("email") as AbstractControl;
    }

    public get phone(): AbstractControl {
        return this.formInstance.get("phone") as AbstractControl;
    }

    public get comment(): AbstractControl {
        return this.formInstance.get("comment") as AbstractControl;
    }

    public static createForm(formBuilder: FormBuilder, initialValues: LotNumberRequestModel): LotNumberRequestForm {
        const form = formBuilder.group({
            lotNumber: formBuilder.control(initialValues.lotNumber),
            name: formBuilder.control(initialValues.name, Validators.required),
            org: formBuilder.control(initialValues.org, Validators.required),
            email: formBuilder.control(initialValues.email, Validators.required),
            phone: formBuilder.control(initialValues.phone, Validators.required),
            comment: formBuilder.control(initialValues.comment)
        });

        return new LotNumberRequestForm(form, initialValues);
    }

    public constructor(
        formInstance: FormGroup,
        initialValues: LotNumberRequestModel
    ) {
        super(formInstance, initialValues);
    }

    protected createChangeSubscription(): Observable<LotNumberRequestModel> {
        return merge(
            this.lotNumber.valueChanges,
            this.name.valueChanges,
            this.org.valueChanges,
            this.email.valueChanges,
            this.phone.valueChanges,
            this.comment.valueChanges
        )
            .pipe(
                switchMapTo(this.formInstance.statusChanges
                    .pipe(filter(this.validate))
                ),
                map(status => this.getModel())
            );
    }

    public showValidationByError(fieldAlias: string, errorAlias: string): boolean {
        const field = this.formInstance.get(fieldAlias);
        if (!field) {
            return false;
        }
        if (!field.dirty && !field.touched) {
            return false;
        }

        if (field.valid) {
            return false;
        }

        return !!field.errors[errorAlias];
    }

    public reset(): void {
        this.lotNumber.setValue("", {emitEvent: false});
        this.name.setValue("", {emitEvent: false});
        this.org.setValue("", {emitEvent: false});
        this.email.setValue("", {emitEvent: false});
        this.phone.setValue("", {emitEvent: false});
        this.comment.setValue("", {emitEvent: false});
    }
}
